import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./form-drop-down.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./form-drop-down.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input, Optional, Output, Self } from "@angular/core";
import { NgControl } from "@angular/forms";
import { SharedConstants } from "../../constants/shared.constants";
let FormDropDownComponent = class FormDropDownComponent {
    ngControl;
    options;
    label;
    parentFormGroup;
    valueChanged;
    selected;
    selectID = "selectID";
    value;
    selectName;
    placeHolderText = SharedConstants.PLACEHOLDER_TEXT;
    constructor(ngControl) {
        this.ngControl = ngControl;
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        this.selectName = this.label.toLowerCase();
    }
    emitValueChange($event) {
    }
    writeValue(value) {
        this.value = value;
    }
    setDisabledState(isDisabled) {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    onTouched() {
    }
    onChange(value) {
    }
    getFirstErrorAvailable() {
        if (this.getFormControl().errors.required) {
            return `${this.label} is required`;
        }
    }
    hasErrors() {
        const formControl = this.getFormControl();
        return formControl.invalid && (formControl.dirty || formControl.touched);
    }
    getFormControl() {
        return this.parentFormGroup.get(this.label);
    }
    static ctorParameters = () => [
        { type: NgControl, decorators: [{ type: Self }, { type: Optional }] }
    ];
    static propDecorators = {
        options: [{ type: Input }],
        label: [{ type: Input }],
        parentFormGroup: [{ type: Input }],
        valueChanged: [{ type: Output }]
    };
};
FormDropDownComponent = __decorate([
    Component({
        selector: "app-form-drop-down[label][options]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], FormDropDownComponent);
export { FormDropDownComponent };
